<template>
  <div class="select-wrapper">
    <label :for="options">
      {{ label }}
      <span v-if="required" class="required-asterisk">*</span>
    </label>
    <select
      class="widget_margin_left"
      :value="modelValue"
      @change="$emit('update:modelValue', $event.target.value)"
      :id="computedSelectId"
      :style="style"
      :required="required"
    >
      <option
        v-for="option in options"
        :key="option"
        :value="option"
        :disabled="option === 'Choose an option'"
      >
        {{ option }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    style: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      required: true
    },
    selectId: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      workingValue: null,
      emitted: false
    }
  },
  computed: {
    computedSelectId() {
      return this.selectId || `select-${this.label.toLowerCase().replace(/\s+/g, '-')}`
    }
  }
}
</script>

<style scoped>
.select-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.widget_margin_left {
  margin-left: 8px;
  color: black;
}

option:disabled {
  color: #999;
  font-style: italic;
}

.required-asterisk {
  color: #ff6b6b;
  margin-left: 2px;
  font-weight: bold;
}
</style>
